<template>
  <CustomPage :noTitle="true">
    <div slot="content">
      <div class="mine-container">
        <div class="content" style="padding-bottom: 50px">
          <Header />
          <div class="overview">
            <Money />
            <Income />
            <Order />
            <Place /><Manage />
          </div>
        </div>
        <Tabbar />
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { mapGetters } from "vuex";
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import Tabbar from "@/components/Tabbar";
import Header from "./components/Header";
import Order from "./components/Order";
import Place from "./components/Place";
import Manage from "./components/Manage";
import Money from "./components/Money";
import Income from "./components/Income";
export default {
  components: {
    CustomPage,
    CustomView,
    Tabbar,
    Header,
    Order,
    Place,
    Manage,
    Money,
    Income,
  },
  computed: {
    ...mapGetters(["distributionFlag"]),
  },
};
</script>

<style lang="less" scoped>
.overview {
  padding: 12px 20px 0;
}
</style>